module.exports = __webpack_public_path__ + "static/cio-on-tap-approach-93696b3fb346f61ed46e8781af819cf6.jpg";